// extracted by mini-css-extract-plugin
export var childrenContainer = "_45-0";
export var virtualScrollArea = "_45-1";